<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> </template>

		<div class="container-fluid" style="text-align: left;">
			<div class="row mt-3">
				<div class="col-sm-3">
					<admin-nav></admin-nav>
				</div>

				<div class="col-sm-9">
					<h4>District Edit</h4>
					<br />

					<div class="col-6">
						<div class="form-group">
							<label for="exampleInputEmail1">Name</label>
							<input type="text" v-model="district.name" class="form-control" />
						</div>
						<div class="form-group">
							<label for="exampleInputEmail1">External ID</label>
							<input type="text" v-model="district.external_id" class="form-control" />
						</div>
						<div class="form-group">
							<label for="exampleInputEmail1">Host URL</label>
							<input type="text" v-model="district.host" class="form-control" />
						</div>
						<div class="form-group">
							<label for="exampleInputEmail1">Programs</label>
							<v-select
								label="name"
								:options="programs"
								@search="programSearch"
								v-model="district.program_ids"
								:clearable="false"
								multiple
								:reduce="(prog) => prog.id"
							></v-select>
						</div>
						<div v-if="district.id" class="form-group d-flex flex-row align-items-end">
							<div class="flex-grow mr-3">
								<label>Teacher Join Code</label>
								<input
									type="text"
									v-model="district.join_code_teacher"
									readonly
									class="form-control join-code"
								/>
							</div>
							<button
								class="btn btn-no-border btn-si-green btn-si-icon mb-2 mr-3"
								@click="regenerateTeacherCode()"
								v-tippy
								title="Re-generate Code"
							>
								<i class="fas fa-sync"></i>
							</button>
						</div>
						<!-- <div v-if="district.id" class="form-group d-flex flex-row align-items-end">
							<div class="flex-grow mr-3">
								<label>Partner Join Code</label>
								<input
									type="text"
									v-model="district.join_code_partner"
									readonly
									class="form-control join-code"
								/>
							</div>
							<button
								class="btn btn-no-border btn-si-green btn-si-icon mb-2 mr-3"
								@click="regeneratePartnerCode()"
								v-tippy
								title="Re-generate Code"
							>
								<i class="fas fa-sync"></i>
							</button>
						</div> -->

						<a href="/#/districts" class="btn float-right">Cancel</a>
						<button @click="save" class="btn btn-primary float-right">
							Save
						</button>
					</div>
				</div>
			</div>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import AdminService from "@/services/AdminService";
import Notie from "@/services/NotieService";

export default {
	name: "AdminLanding",

	props: ["user"],

	components: { MainPage, AdminNav },

	data() {
		return {
			service: AdminService,
			district: {},
			roles: ["ADMIN", "TEACHER", "STUDENT", "PARTNER"],
			programs: [],
		};
	},

	created() {
		var id = this.$route.params.id;
		if (id == "new") {
			this.district = {
				name: "",
				program_ids: [],
				enabled: true,
				host: window.location.host,
			};
			this.loadPrograms();
			return;
		}

		this.loadData(id);
	},

	methods: {
		loadData(id) {
			this.service
				.getDistrict(id)
				.then((resp) => {
					this.district = resp.data;
				})
				.catch((err) => {
					alert(err);
				});
			this.loadPrograms();
		},

		loadPrograms() {
			console.log("loading programs")
			AdminService.listPrograms({ filter: "" }).then((resp) => {
				this.programs = resp.data.result;
			});
		},

		save() {
			this.service
				.saveDistrict(this.district)
				.then(() => {
					window.location.href = "/#/districts";
				})
				.catch((err) => {
					alert(err);
				});
		},

		programSearch(search, loading) {
			console.log(search, loading);
			AdminService.listPrograms({ filter: search }).then((resp) => {
				this.programs = resp.data.result;
			});
		},

		regenerateTeacherCode() {
			this.service
				.regenerateTeacherCode(this.district.id)
				.then(() => {
					this.loadData(this.district.id);
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to regenerate code", e);
				});
		},

		regeneratePartnerCode() {
			this.service
				.regeneratePartnerCode(this.district.id)
				.then(() => {
					this.loadData(this.district.id);
				})
				.catch((e) => {
					console.log(e);
					Notie.error("Failed to regenerate code", e);
				});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.join-code {
	font-size: 24px;
	text-align: center;
}
</style>
